// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    actualCompletionDate: 'Werkelijke afrondingsdatum:',
    actualCompletionDateFull: 'Werkelijke afrondingsdatum',
    AutoAssign_Issue: 'Nieuwe problemen automatisch toewijzen aan:',
    AutoAssign_Note: 'De gekozen persoon zal bij elk nieuw projectlid aan het project worden toegewezen.',
    AutoAssign_Request: 'Nieuwe verzoeken automatisch toewijzen aan:',
    AutoAssign_Task: 'Nieuwe taken automatisch toewijzen aan:',
    AutoAssign_Title: 'Automatisch toewijzen',
    BaselineCapturedFeedback: 'De projectbasislijn is vastgelegd. Ga naar een Gantt-weergave en kies de optie \'Weergeven\' om deze te controleren.',
    BaselineCaptureLabel: 'Basislijn vastleggen',
    BaselineOverwrite: 'De huidige basislijn overschrijven?',
    BaselineOverwriteDescription: 'U heeft al een basislijn voor dit project. Als u doorgaat, gaat de huidige basislijn verloren.',
    BaselineOverwrittenFeedback: 'De projectbasislijn is overschreven. Ga naar een Gantt-weergave en kies de optie \'Weergeven\' om deze te controleren.',
    BaselineRecaptureLabel: 'Basislijn overschrijven',
    BaselineSuccess: 'De basislijn is succesvol vastgelegd.',
    Billed: 'Gefactureerd',
    Billing: 'Facturering',
    BillingSettingsTitle: 'Factureringsinstellingen',
    BillingTypeNotBillable: 'Niet factureerbaar',
    BillingTypeProjectBillingSettings: 'Projectfactureringsinstellingen',
    btnNotifications: 'Meldingen',
    BudgetLeft: 'overgebleven',
    BudgetTotal: 'totaal',
    By: 'door ',
    Change: 'wijziging',
    Close: 'Sluiten',
    ConfirmStatusDialogTitle: '\"{0}\" voltooien?',
    DayPluralFormat: '1#{0} dag#{0} dagen',
    Days: '({0}d)',
    DeleteActivity: 'Activiteit verwijderen',
    DeleteProject: 'Project verwijderen',
    Dependencies_Count: '1#{0} afhankelijkheid#{0} afhankelijkheden',
    DifferPermissionsMessage: 'geeft aan dat de toestemmingen van het huidige projectlid verschillen van de standaardroltoestemmingen',
    Disable_Dates_Rollup: 'Datumsamenvatting uitschakelen',
    Disable_Dates_Rollup_Feedback: 'Datumsamenvatting is uitgeschakeld.',
    DueIn_Ok: 'vervalt in {0}',
    DueIn_Trouble: '{0} achterstallig',
    DueIn_Warning: 'vervalt vandaag',
    EditRoleAndPermissions: 'Rol en toestemmingen bewerken',
    Enable_And_Reschedule: 'Inschakelen en opnieuw plannen',
    Enable_Dates_Rollup: 'Datumsamenvatting inschakelen',
    Enable_Dates_Rollup_Description: 'Het inschakelen van de datumsamenvatting zal dit project opnieuw plannen.',
    Enable_Dates_Rollup_Feedback: 'Datumsamenvatting is ingeschakeld.',
    Enable_Dates_Rollup_Title: 'Projectdatums worden bijgewerkt.',
    endDate: 'Geplande einddatum: ',
    endDateFull: 'Geplande einddatum',
    endLessThenStartMsg: '\'Einddatum\' kan niet eerder zijn dan \'Startdatum\'',
    estimatedHours: '1# geschat uur# geschatte uren',
    ExportToMsProject: 'Exporteren naar MS Project',
    Fields: '1#{0} veld#{0} velden',
    FillCustomFields: '{0} moet nog worden ingevuld',
    Follow: 'Volgen',
    hide_checklist_label: 'Checklist verbergen',
    HideCustomFields: 'Aangepaste velden verbergen',
    hoursLeft: '1# uur over# uur over',
    HoursOf: 'u van ',
    HtmlField_ReadAll: '... alles lezen',
    ImDoneText: 'Ik ben klaar',
    IsMilestone: 'Dit is een mijlpaal',
    issue: 'Probleem',
    MarkAsMilestone: 'Markeren als mijlpaal',
    MemberPermission_Add: 'Toevoegen',
    MemberPermission_Add_For_Someone_Else: 'Toevoegen voor iemand anders',
    MemberPermission_Add_Own: 'Zelf toevoegen',
    MemberPermission_CanEditActualExpenses: 'Werkelijke kosten bewerken',
    MemberPermission_CanEditPlannedExpenses: 'Geplande kosten bewerken',
    MemberPermission_CanLogExpenses: 'Kosten registreren',
    MemberPermission_CanManageProjectMembers: 'Leden en toestemmingen beheren',
    MemberPermission_CanManageProjectMembersAndAllocations: 'Leden, toestemmingen en toewijzingen beheren',
    MemberPermission_CanViewMembersAndAssignees: 'Bekijken',
    MemberPermission_Delete: 'Verwijderen',
    MemberPermission_Delete_All: 'Alles verwijderen',
    MemberPermission_Delete_Or_Archive: 'Verwijderen/Archiveren',
    MemberPermission_Edit: 'Bewerken',
    MemberPermission_Edit_All: 'Alles bewerken',
    MemberPermission_Edit_Assigned: 'Toegewezen bewerken',
    MemberPermission_Manage_Assigned: 'Toegewezen beheren',
    MemberPermission_View_All: 'Alles bekijken',
    MemberPermission_View_and_Manage: 'Bekijken en beheren',
    MemberPermission_View_Assigned: 'Toegewezen bekijken',
    MemberPermissions_ExpensesTitle: 'Kosten:',
    MemberPermissions_MembersAndAssigneesTitle: 'Leden en toegewezen personen:',
    MemberPermissions_TasksTitle: 'Activiteiten:',
    MemberPermissions_ThisProjectTitle: 'Project:',
    MemberPermissions_TimeEntriesTitle: 'Tijdsvermeldingen:',
    Members: '1#{0} Lid#{0} Leden',
    no_assignee: 'Geen toegewezen persoon',
    On: ' op ',
    OwnBudget: 'Budget voor deze activiteit:',
    PercentDone: '1#% voltooid#% voltooid',
    PermissionsSettingsTitle: 'Toestemmingen van {0}',
    project: 'Project',
    Project_NotFound_Message: 'Het opgevraagde project kon niet worden gevonden of u heeft geen toestemming om het te openen. Raadpleeg uw {brandName} beheerder voor mogelijke oorzaken. Object sleutel is {0}.',
    Project_NotFound_Title: 'Opgevraagd project niet gevonden',
    Project_WasCompleted_Ok: 'Project was <b>{0} vóór</b> de geplande einddatum voltooid.',
    Project_WasCompleted_Trouble: 'Project was <b>{0} na</b> de geplande einddatum voltooid.',
    Project_WasCompleted_Warning: 'Project was op de geplande einddatum voltooid.',
    RatioOfMoneySpent: '1#{0} van {1} uitgegeven#{0} van {1} uitgegeven',
    RepeatActivity: 'Herhalen',
    request: 'Verzoek',
    ResumeWorkHelpText: 'U heeft uw opdracht voltooid. ',
    ResumeWorkText: 'Hervat werk',
    RoleTitle: 'Rol voor dit project',
    Save: 'Opslaan',
    Set_actualCompletionDate: 'Werkelijke afrondingsdatum instellen',
    Set_budget: 'Budget instellen',
    Set_categoryId: 'Categorie instellen',
    Set_customerId: 'Klant instellen',
    Set_dates: 'Datums of duur instellen',
    Set_description: 'Beschrijving toevoegen',
    Set_endDate: 'Geplande einddatum instellen',
    Set_estimatedHours: 'Geschatte uren instellen',
    Set_hoursLeft: 'Overgebleven uren instellen',
    Set_labor_budget: 'Arbeidsbudget instellen',
    Set_portfolioId: 'Portfolio instellen',
    Set_short_hoursLeft: 'Overgebleven uren instellen',
    SetAsRootLevel: 'Als topniveau-activiteit instellen',
    SetCompleted: 'Als voltooid instellen',
    short_hoursLeft: '1# uur over# uren over',
    show_checklist_label: 'Checklist weergeven',
    ShowCustomFields: 'Aangepaste velden weergeven',
    Spent: '1# uur besteed# uren besteed',
    Status: 'Status: ',
    task: 'Taak',
    Task_NotFound_Message: 'De gevraagde activiteit kon niet worden gevonden of je hebt geen toestemming om deze te openen. Raadpleeg uw {brandName}-beheerder voor mogelijke oorzaken. Object sleutel is {0}.',
    Task_NotFound_Title: 'Gevraagde activiteit niet gevonden',
    Task_WasCompleted_Ok: 'Activiteit werd <b>{0} vóór</b> de geplande einddatum voltooid',
    Task_WasCompleted_Trouble: 'Activiteit werd <b>{0} na</b> de geplande einddatum voltooid',
    Task_WasCompleted_Warning: 'Activiteit werd op de geplande einddatum voltooid',
    today: 'Vandaag',
    UnFollow: 'Ontvolgen',
    WindowUnload_UnsavedChanges: 'Er zijn niet-opgeslagen wijzigingen. Weet je zeker dat je deze pagina wilt verlaten?',
};
